export default __webpack_public_path__ + "78dcce3c536f70037202a007e3436565.png";